import "./TemplatePage.css";

import React, { useEffect, useState } from "react";

import axios from "axios";

import { useParams } from "react-router-dom";

import { END_URL } from "../../config";

import gg from "../../images/pp-logo.gif";

function TemplatePage() {

    const { slug } = useParams();

    const [page, setPage] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    useEffect(() => {

        fetchPage();

    }, [slug]);

    const fetchPage = async () => {

        try {

            setLoading(true);

            const response = await axios.get( `${END_URL}/template/${slug}`);
               
            if (response.data.success) {

                setPage(response.data.data);

            } else {

                setError("Page not found");
            }

        } catch (error) {

            console.log(error);

            setError("Failed to load page");

        } finally {

            setLoading(false);
        }
    };

    if (loading) {

        return (
               <div className="loadingDiv" >
                
                    <img src={gg}  alt="Loading..." />
        
                </div>
        );
    }

    if (error) {

        return (
            <div className="container py-5 text-danger">
                {error}
            </div>
        );
    }

    return (
        <div className="priv-main">

            <div className="container">

                <div className="row">

                    <div className="col-md-12 priv-text-div">

                        <div className="priv-title">

                            <h1>
                                {page?.title}
                            </h1>

                        </div>

                        {page?.contents?.map((item) => (

                            <div
                                key={item.id}
                                className="priv-text mb-4"
                                dangerouslySetInnerHTML={{
                                    __html: item.content
                                }}
                            />

                        ))}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default TemplatePage;